/**
 * Pure component for common enum dropdown
 */
import { forwardRef, useMemo } from 'react';
import {
  RfiSingleSelectEnumsOptionsMapping,
  getRFIEnumOptions,
} from '../../../helpers/enumOptionsHelpers';
import { SingleSelectDropdown } from '../../Dropdowns/SingleSelectDropdown';
import { CommonFormField } from '../CommonFormField';

export type PureEnumDropdownProps = {
  fieldName: keyof RfiSingleSelectEnumsOptionsMapping;
  value?: string;
  onChange: (value: string) => void;
  id?: string;
  label?: string;
  required?: boolean;
  error?: string;
  disabled?: boolean;
  placeholder?: string;
  clearable?: boolean;
  isOpen?: boolean;
  onClose?: () => void;
};

export const PureEnumDropdown = forwardRef<HTMLDivElement, PureEnumDropdownProps>(
  (
    {
      fieldName,
      value,
      onChange,
      id,
      label,
      required,
      error,
      disabled,
      placeholder,
      clearable,
      isOpen,
      onClose,
    },
    ref,
  ) => {
    const options = useMemo(() => getRFIEnumOptions(fieldName), [fieldName]);

    return (
      <CommonFormField label={label} required={required} error={error} ref={ref}>
        <SingleSelectDropdown
          id={id || fieldName}
          disabled={disabled}
          onChange={onChange}
          options={options}
          value={value}
          placeholder={placeholder}
          clearable={clearable}
          isOpen={isOpen}
          onClose={onClose}
          error={!!error}
        />
      </CommonFormField>
    );
  },
);
